var exports = {
  "kL": "ChannelChatLayout.module__container___dXBDeC",
  "zX": "ChannelChatLayout.module__flybyHost___dXBDeC",
  "TB": "ChannelChatLayout.module__scareHost___dXBDeC",
  "Yx": "ChannelChatLayout.module__messagesArea___dXBDeC",
  "gA": "ChannelChatLayout.module__textareaArea___dXBDeC",
};

module.exports = exports;
